import styled from "styled-components";
import { colours } from "../../../../styles/colours.constants";
import { PostType } from "../../../../types/post.types";
import { BasePostStyles, BaseTitle, Text } from "../../posts.styles";

export const Post = styled.div`
	${BasePostStyles}
	border-left-width: 6px;
	border-left-color: ${colours.yellow};
	border-left-style: solid;
`;

type TitleStyleProps = {
	$type?: PostType;
};

const getKeyMomentTitleColour = ($type?: PostType) => {
	if ($type === PostType.PENALTY) {
		return colours.black;
	}

	return colours.yellow;
};

export const Title = styled.div<TitleStyleProps>`
	${BaseTitle}
	color: ${({ $type }) => getKeyMomentTitleColour($type)};
`;

export { Text, BaseTitle };
